import { Component, Input, OnInit } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
import { DocumentModel } from '../../../../models/document.model'
import { DocumentsService } from '../../../../services/documents.service'
import { forkJoin } from 'rxjs/observable/forkJoin'
import { ResourceLoadingService } from '../../../../services/resource-loading.service'
import { Observable } from 'rxjs'

@Component({
  selector: 'app-document-details-view',
  templateUrl: './document-details-view.component.html',
  styleUrls: ['./document-details-view.component.scss'],
})
export class DocumentDetailsViewComponent implements OnInit {
  @Input() document: DocumentModel

  originalFile: any
  modifiedFile: any
  originalFileType: string
  modifiedFileType: string
  public innerHtml: any
  constructor(
    private _documentService: DocumentsService,
    private _sanitizer: DomSanitizer,
    private _loadingService: ResourceLoadingService,
  ) {}

  ngOnInit() {
    this._loadingService.loading(true)
    this.innerHtml = forkJoin(
      this._documentService.download(this.document, true),
      this._documentService.download(this.document, false),
      (original, modified) => {
        this.createOrgImageFromBlob(original)
        this.createModImageFromBlob(modified)
      },
    )
      .do(() => {})
      .subscribe(() => {
        this._loadingService.loading(false)
      })
  }

  createOrgImageFromBlob(image: Blob) {
    const reader = new FileReader()
    reader.addEventListener(
      'load',
      () => {
        this.originalFile = reader.result
        if (image.type == 'application/pdf') {
          this.originalFile = reader.result
          this.originalFileType = 'document'
        } else {
          this.originalFile = this._sanitizer.bypassSecurityTrustResourceUrl(reader.result as string)
          this.originalFileType = 'image'
        }
      },
      false,
    )

    if (image) {
      reader.readAsDataURL(image)
    }
  }
  createModImageFromBlob(image: Blob) {
    const reader = new FileReader()
    reader.addEventListener(
      'load',
      () => {
        this.modifiedFile = this._sanitizer.bypassSecurityTrustResourceUrl(reader.result as string)
        if (image.type == 'application/pdf') {
          this.modifiedFile = reader.result
          this.modifiedFileType = 'document'
        } else {
          this.modifiedFile = this._sanitizer.bypassSecurityTrustResourceUrl(reader.result as string)
          this.modifiedFileType = 'image'
        }
      },
      false,
    )

    if (image) {
      reader.readAsDataURL(image)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/documents/document-details/document-details-view/document-details-view.component.ts